import { ImageVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant'
import { RGBVariantProps } from 'common/Prose/nodeViews/Image/components/ImageVariant/Types'
import Styles from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Slider } from 'almanac-ui/Slider/Slider'
import { blue, green, red } from '@cloudinary/url-gen/actions/adjust'
import { useImageStore } from 'stores/ImageStore'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { useState } from 'react'
import { useId } from '@react-aria/utils'

export const RGBVariant = (props: RGBVariantProps) => {
  const { variant } = props
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()
  const [localRed, setLocalRed] = useState(variant.action === 'red' ? variant.qualifier ?? 0 : 0)
  const [localGreen, setLocalGreen] = useState(variant.action === 'green' ? variant.qualifier ?? 0 : 0)
  const [localBlue, setLocalBlue] = useState(variant.action === 'blue' ? variant.qualifier ?? 0 : 0)
  const redLabelId = useId()
  const greenLabelId = useId()
  const blueLabelId = useId()

  if (!cloudinary) return null

  return (
    <ImageVariant {...props}>
      <div className={Styles.rgbValue}>
        <Text variant="smallList" id={redLabelId}>
          Red
        </Text>
        <Slider
          aria-labelledby={redLabelId}
          minValue={-100}
          maxValue={100}
          pinnedValue={0}
          step={1}
          filled
          onChange={(value) => setLocalRed(value as number)}
          value={localRed}
          onChangeEnd={(value) => {
            const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
            image
              .effect(red(value as number))
              .effect(green(localGreen))
              .effect(blue(localBlue))
            imageStore.clearVariants()
            imageStore.createVariant({ image, url: image.toURL(), action: 'red', qualifier: value as number })
            setLocalRed(value as number)
          }}
        />
      </div>
      <div className={Styles.rgbValue}>
        <Text variant="smallList" id={greenLabelId}>
          Green
        </Text>
        <Slider
          aria-labelledby={greenLabelId}
          minValue={-100}
          maxValue={100}
          pinnedValue={0}
          filled
          step={1}
          onChange={(value) => setLocalGreen(value as number)}
          value={localGreen}
          onChangeEnd={(value) => {
            const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
            image
              .effect(green(value as number))
              .effect(red(localRed))
              .effect(blue(localBlue))
            imageStore.clearVariants()
            imageStore.createVariant({ image, url: image.toURL(), action: 'green', qualifier: value as number })
            setLocalGreen(value as number)
          }}
        />
      </div>
      <div className={Styles.rgbValue}>
        <Text variant="smallList" id={blueLabelId}>
          Blue
        </Text>
        <Slider
          aria-labelledby={blueLabelId}
          minValue={-100}
          maxValue={100}
          pinnedValue={0}
          step={1}
          filled
          onChange={(value) => setLocalBlue(value as number)}
          value={localBlue}
          onChangeEnd={(value) => {
            const image = cloudinary.image(variant.sourceUrl.split('?')[0]).setDeliveryType('fetch')
            image
              .effect(green(localGreen))
              .effect(red(localRed))
              .effect(blue(value as number))
            imageStore.clearVariants()
            imageStore.createVariant({ image, url: image.toURL(), action: 'blue', qualifier: value as number })
            setLocalBlue(value as number)
          }}
        />
      </div>
    </ImageVariant>
  )
}
